

import action from './action';
import * as F from 'utils/F';
import Icon from 'vux/src/components/icon/index.vue'

import { yoButton } from 'components';

var userAgent = navigator.userAgent;
var phoneType = userAgent.indexOf('iPhone') > -1 ? 'iPhone' : 'android';

var isWeChat = userAgent.indexOf('MicroMessenger') > -1;

export default {
name: 'index',
props: ['params'],
metaInfo: {
title: '下载APP'
},
created: async function () {
this.getInfo();
},
data() {
return {
cdn: G.cdn,
isWeChat: isWeChat,
phoneType: phoneType,
androidDownload: '',
iosDownload: '',
enterpriseNo: this.params.enterprise || this.params.enterpriseNo
};
},
computed: {},
components: {
Icon,
yoButton
},
methods: {
...action
},
beforeRouteEnter(to, from, next) {
console.log('goods beforeRouteEnter');
action.addShare(to);
next();
},
beforeRouteUpdate(to, from, next) {
console.log('goods beforeRouteUpdate');
action.addShare(to);
next();
}
};



// WEBPACK FOOTER //
// ./src/module/app/download/page.vue